module.exports = __webpack_public_path__ + "img/nightingale_title--available.64cf7784.png";